import styled from 'styled-components';

const RoundedButtonWrapper = styled.button`
	width: 35px;
	height: 35px;
	border-radius: 10rem;
	border: 0;
	margin: 5px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	svg {
		width: 20px;
		fill: #fff;
	}
	&.primary {
		background: #42a6ff;
	}
	&.success {
		background: #25bf5d;
	}
	&.warning {
		background: #ff9d46;
	}
	&.danger {
		background: #ff5a5a;
	}
`;

export default styled.button`
	width: calc(100% - 20px);
	margin: 10px;
	appearance: none;
	border: 0;
	background: #393969;
	padding: 15px;
	border-radius: 8px;
	color: #fff;
	font-weight: bold;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export { RoundedButtonWrapper };
